import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageHeader1 from "../../components/common/PageHeader1";
import { getCMSPages, updateCmsApi } from "../../services/Cms";

function AboutUsCMS() {
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorValue, setEditorValue] = useState("");
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [cmsId, setCmsId] = useState(null);

  
  useEffect(() => {
    (async () => {
      try {
        const res = await getCMSPages("about-us");
        console.log(res?.data.data);
        if (res?.data) {
          const data = res.data;
          setEditorValue(data.content || "");
          setImagePreview(`${data.image}`);
          setCmsId(data._id); // Required for update
        }
      } catch (error) {
        console.error("Failed to load CMS data:", error);
      }
    })();
  }, []);

  const onSubmit = async () => {
    if (!editorValue) {
      toast.error("Description is required");
      return;
    }

    const payload = {
      pageType: "about-us",
      _id: cmsId, // Use cmsId for update
      imageFile,
      content: editorValue,
    };
    console.log("Payload for update:", payload);
    try {
      const res = await updateCmsApi(payload);
      if (res?.success) {
        toast.success("About Us updated successfully");
      } else {
        toast.error("Failed to update About Us");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle="Edit About Us"
        navigation="CMS"
        // navlink="/cms"
        current="About Us"
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>Edit About Us Page</h2>
            </div>

            <div className="col-md-6">
              <label className="form-label">Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ maxHeight: "200px" }}
                />
              )}
            </div>

            <div className="col-md-12">
              <label className="form-label">Description</label>
              <ReactQuill
                theme="snow"
                value={editorValue}
                onChange={setEditorValue}
                placeholder="Enter about us content..."
              />
              {!editorValue && <p className="text-danger mt-1">Description is required</p>}
            </div>

            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5">
                Save Changes
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AboutUsCMS;
